import { Select as SelectPrimitive } from "@base-ui/react/select"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const TRIGGER_VARIANTS = {
  input: [
    "relative flex h-10 w-full cursor-default items-center justify-between rounded border bg-white px-2 text-left text-sm outline-none",
    "focus:border-blue-600",
    "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500",
  ].join(" "),
  button: "btn btn-secondary",
  cell: [
    "flex h-10 w-full min-w-32 cursor-default items-center justify-between gap-1 rounded border bg-white px-2 py-1 text-sm outline-none",
    "focus:border-blue-600",
    "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500",
  ].join(" "),
}

const SelectTrigger = ({
  className,
  variant = "input",
  hasErrors = false,
  children,
  ...props
}) => (
  <SelectPrimitive.Trigger
    data-slot="select-trigger"
    className={classNames(
      TRIGGER_VARIANTS[variant],
      { "border-red-600": hasErrors },
      className
    )}
    {...props}
  >
    <span className="block w-11/12 truncate">{children}</span>
    <SelectPrimitive.Icon
      className={classNames(
        "pointer-events-none flex shrink-0 items-center",
        variant === "button" ? "ml-2" : "pr-1"
      )}
    >
      <i
        className={classNames("text-gray-600", {
          "fa-solid fa-chevron-down text-xxxs": variant === "button",
          "fa-solid fa-chevron-down text-xs": variant !== "button",
        })}
      />
    </SelectPrimitive.Icon>
  </SelectPrimitive.Trigger>
)

SelectTrigger.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(["input", "button", "cell"]),
  hasErrors: PropTypes.bool,
  children: PropTypes.node,
}

export default SelectTrigger
